import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from "../../../services/http-client.service";
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { ActivatedRoute } from "@angular/router";
let ChangeWalletPasswordComponent = class ChangeWalletPasswordComponent {
    constructor(httpClient, sanitizer, themeService, route) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.route = route;
        this.walletPassword = '';
        this.confirmedWalletPassword = '';
        this.resetButtonDisabled = true;
        this.validPassword = false;
        this.validConfirmPassword = true;
        this.validMfa = true;
        this.errorMessage = '';
        this.passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,64}$/;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.linkColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.resetButtonClicked = false;
        this.showNewWalletPassword = false;
        this.showNewWalletPasswordAgain = false;
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
        });
        this.route.params.subscribe((params) => {
            this.token = params['token'];
        });
    }
    ngOnInit() {
    }
    changePassword() {
        this.resetButtonClicked = true;
        if (this.resetButtonDisabled || this.mfaCode.length !== 6) {
            return;
        }
        this.errorMessage = '';
        const passphraseData = {
            passphrase: this.walletPassword,
            passphraseConfirmed: this.confirmedWalletPassword,
            token: this.data.token,
        };
        this.httpClient.get('mfa/checkmfacode?mfa_code=' + this.mfaCode).subscribe((data) => {
            const validMfa = data['isValid'];
            if (validMfa) {
                this.httpClient.post('wallet/resetpassphrase', passphraseData).subscribe((data) => {
                    this.close();
                    this.success();
                }, (error) => {
                    this.close();
                    this.error();
                });
            }
            else {
                this.validMfa = false;
                this.resetButtonClicked = false;
            }
        });
    }
    checkValidation(event) {
        if (this.passRegex.test(this.walletPassword)) {
            this.validPassword = true;
        }
        else {
            this.validPassword = false;
            this.resetButtonDisabled = true;
            return;
        }
        if (!this.confirmedWalletPassword) {
            return;
        }
        else {
            if (this.walletPassword === this.confirmedWalletPassword) {
                this.validConfirmPassword = true;
            }
            else {
                this.validConfirmPassword = false;
                this.resetButtonDisabled = true;
                return;
            }
        }
        if (this.walletPassword !== '' && this.confirmedWalletPassword !== '') {
            this.resetButtonDisabled = false;
        }
        if (this.mfaCode && this.mfaCode.length === 6) {
            this.resetButtonDisabled = false;
        }
        else {
            this.resetButtonDisabled = true;
            return;
        }
        if (event.keyCode === 13 && !this.resetButtonDisabled) {
            this.changePassword();
        }
    }
    sendResetPasswordMail() {
        this.data.step = 2;
        this.httpClient.post('wallet/forgotpassphrase', { fromWallet: false }).subscribe();
    }
    close() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
};
ChangeWalletPasswordComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: ActivatedRoute }
];
ChangeWalletPasswordComponent = __decorate([
    Component({
        selector: 'ecd-change-wallet-password',
        template: __importDefault(require("./change-wallet-password.component.html")).default,
        encapsulation: ViewEncapsulation.None,
    })
], ChangeWalletPasswordComponent);
export { ChangeWalletPasswordComponent };
